export default __webpack_public_path__ + "static/media/cost.ee1d6f95.svg";